import { useTranslation } from 'react-i18next';
import { LanguageString } from '@myriadgenetics/mgh-types';
import Button from '../../elements/button';
import { Text1, Text2 } from '../../elements/typography';

import './index.scss';
import LanguageSelect, { SelectionType } from '../language-select';
import Card from '../rac/card';

interface Props {
  onContinue: () => void;
}

function LanguagePage({ onContinue }: Props) {
  const { t, i18n } = useTranslation();

  const triggerContinue = (lang: LanguageString) => {
    i18n.changeLanguage(lang);

    onContinue();
  };

  return (
    <div className="language-page">
      <Card>
        <h1 className="heading-medium--semi-bold color-gray-900">{t('start.title')}</h1>
        <Text1 className="language-page__select-language heading-small--regular" data-testid="language-page-select-language">
          <span className="heading-small--regular">{t('start.selectLanguage')}</span>
          <LanguageSelect type={SelectionType.Dropdown} size="large" />
        </Text1>
        <Text1 className="language-page__description">{t('start.briefQuestionnaire')}</Text1>
        <Button className="language-page__start-button" dataTestId="continue-button" onClick={() => triggerContinue(i18n.language as LanguageString)}>
          {t('start.startBtn')}
        </Button>
        <Text2 className="language-page__disclaimer">
          <p className="text-x-small--regular">{t('start.doesNotDiagnose')}</p>
          <p className="text-x-small--regular">{t('start.askYourProvider')}</p>
        </Text2>
      </Card>
    </div>
  );
}

export default LanguagePage;
